import React from 'react';
import { Link } from 'react-router-dom';
import type { LessonPlan } from '../../../types/v2';

export function PlanCompletionSummary({ plan }: { plan: LessonPlan }) {
  const requirements = plan.completion_requirements;
  const required = (requirements || []).filter(step => step.completion_role === 'required');
  return <div className="mt-2 rounded border border-indigo-200 bg-indigo-50 p-2 text-xs text-indigo-950">
    <p className="font-semibold">Required live work: {requirements ? required.length ? required.map(step => step.title).join(' · ') : 'None configured' : 'Review lesson plan'}</p>
    <p className="mt-1">{requirements ? `${requirements.filter(step => step.completion_role === 'check').length} checks for understanding · ${requirements.filter(step => step.completion_role === 'optional').length} optional activities. ` : ''}These settings carry into the run.</p>
    <Link className="mt-1 inline-block underline" to={`/v2/teacher/lesson-plan/${plan.id}/edit`}>Review or adjust in lesson plan</Link>
  </div>;
}
